"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_TITLE_LENGTH = void 0;
exports.isEmailValid = isEmailValid;
exports.isUrlValid = isUrlValid;
var MIN_TITLE_LENGTH = 3;
exports.MIN_TITLE_LENGTH = MIN_TITLE_LENGTH;

function isEmailValid(email) {
  var re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(email);
}

function isUrlValid(url) {
  var urlPattern = /^(http|https):\/\/[^ "]+$/;
  var componentRegex = /^((%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@\x26=+$,A-Za-z0-9])+)([).!';/?:,])?$/;

  if (!urlPattern.test(url)) {
    return false;
  }

  try {
    var parsedUrl = new URL(url);
    var path = parsedUrl.pathname;
    var query = parsedUrl.search;
    var fragment = parsedUrl.hash;
    var isPathValid = path === '' || componentRegex.test(path);
    var isQueryValid = query === '' || componentRegex.test(query.slice(1));
    var isFragmentValid = fragment === '' || componentRegex.test(fragment.slice(1));
    return isPathValid && isQueryValid && isFragmentValid;
  } catch (e) {
    return false;
  }
}